import { render } from "./customizeByFlight.vue?vue&type=template&id=02556bc0&scoped=true"
import script from "./customizeByFlight.vue?vue&type=script&lang=js"
export * from "./customizeByFlight.vue?vue&type=script&lang=js"

import "./customizeByFlight.vue?vue&type=style&index=0&id=02556bc0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02556bc0"]])

export default __exports__